import { REQUEST_FETCH_CAMPAIGN, FETCH_CAMPAIGN_SUCCESS, FETCH_CAMPAIGN_ERROR } from './actionTypes';

export const requestFetchCampaign = () => ({ type: REQUEST_FETCH_CAMPAIGN });
export const fetchCampaignSuccess = campaign => ({ type: FETCH_CAMPAIGN_SUCCESS, payload: campaign });
export const fetchCampaignError = error => ({ type: FETCH_CAMPAIGN_ERROR, payload: error });
